import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IUserState } from './user-state.store';
import {
  USER_INFO,
  USER_INFO_STATUS,
  USER_INFO_RECIEVED,
  USER_INFO_UPDATE,
  USER_INFO_PATCH,
  USER_SIGN_UP,
  USER_SIGN_UP_VERIFY_BLOCK,
  USER_SIGN_UP_VERIFY,
  USER_INFO_EDIT,
  USER_ACTION,
  USER_INIT,
  USER_RESET_USER, USER_ACTION_TYPE
} from './user-types.store';
import { ActivityStatus, CrudStatus, UserTemplate } from '../../common/enums';
import { IUserService } from '../../services';
import { IUserDetails, VCreateUserModel } from '../../models/user';
import VueRouter from 'vue-router';

export const actions: ActionTree<IUserState, IRootState> = {

  [USER_INFO]:
    async ({ getters, commit, state }, router: VueRouter) => {

      if (state.activityStatus === ActivityStatus.Loading) {
        return state.userInfo
      }
      commit(USER_INFO_STATUS, ActivityStatus.Loading);
      await state.service.getUserInfo()
        .then(res => {
          commit(USER_INFO_STATUS, ActivityStatus.Loaded)
          commit(USER_INFO_RECIEVED, res);
          if (location.pathname === '/') {
            if (router.currentRoute.query.redirectTo) {
              location.href = decodeURI(router.currentRoute.query.redirectTo);
            } else {
              location.href = '/home';
             /*  if(res.template === UserTemplate.default)
              {
                location.href = '/home';
              } else {
                location.href = '/service-book';
              } */
            }
          }
        })
        .catch(error => {
          commit(USER_INFO_STATUS, ActivityStatus.LoadFailed)
          commit('authorization/AUTHORIZATION_SIGN_IN_FAILED', null, { root: true })
          router.push('/')
        })
      // if (state.activityStatus === ActivityStatus.Loading) {
      //   return {}
      // }
      // commit(USER_INFO_STATUS, ActivityStatus.Loading);
      // return await (getters.service as IUserService).getUserInfo()
      //   .then((userInfo: IUserDetails) => {
      //     commit(USER_INFO_RECIEVED, userInfo);
      //     commit(USER_INFO_STATUS, ActivityStatus.Loaded);
      //     return userInfo;
      //   })
      //   .catch(error => {
      //     commit(USER_INFO_STATUS, ActivityStatus.LoadFailed);
      //     localStorage.clear();
      //     return Promise.reject(error);
      //   })
    },

  [USER_INFO_UPDATE]:
    async ({ getters, commit, state }, payload: any) => {
      try {
        if (state.activityStatus === ActivityStatus.Loading) return;
        commit(USER_INFO_STATUS, ActivityStatus.Loading);
        return await (getters.service as IUserService).updateUserInfo(getters.userInfo.id, payload)
          .then((userInfo: IUserDetails) => {
            commit(USER_INFO_PATCH, userInfo);
            commit(USER_INFO_STATUS, ActivityStatus.Loaded);
            return Promise.resolve(userInfo);
          })
          .catch(error => {
            commit(USER_INFO_STATUS, ActivityStatus.LoadFailed);
            return Promise.reject(error);
          })
      } catch (error) {
        return Promise.reject(error);
      }
    }
  , [USER_SIGN_UP]: async ({ commit, state }, payload: VCreateUserModel) => {
    return await state.service!.register(payload)
  }
  , [USER_SIGN_UP_VERIFY_BLOCK]: async ({ commit, state }, blockCode: string) => {
    return await state.service!.validateBlock(blockCode)
  }
  , [USER_SIGN_UP_VERIFY]: async ({ commit, state }, token: string) => {
    return await state.service!.verifyRegisterToken(token)
  }
  , [USER_INFO_EDIT] : async ({ commit, getters }, actionType) => {
      const service: IUserService = getters.service
    const { id, role_id, fk_entity_civility_legal_form, firstname, lastname, email, landline, cellphone, signature, trigram, problem_solver } = <IUserDetails>getters.userInfo
      commit(USER_INIT, service.initUser({
         id,
         role: role_id ,
         civility: fk_entity_civility_legal_form,
         firstname,
         lastname,
         email,
         landline,
         cellphone,
         signature,
         trigram,
         specialization: problem_solver,
      }))
      commit(USER_ACTION, CrudStatus.Update)
      commit(USER_ACTION_TYPE, actionType)
  },
  [USER_RESET_USER]: async ({ commit, getters }) => {
    const service: IUserService = getters.service
    commit(USER_ACTION,CrudStatus.NoAction)
    commit(USER_INIT,service.initUser())
  }
}



// WEBPACK FOOTER //
// ./src/store/user/user-actions.store.ts